import { IoIosArrowDown } from 'react-icons/io';
import { ACTIVE_NETWORKS, ChainId, NETWORK_LOGOS } from '@shared/utils/config/networks';
import classNames from '@/lib/misc/classNames';
import { getNetworkName, toSpecialFixed } from '@/lib/misc/utils';
import ImageWithFallback from '../shared/ImageWithFallback';
import { TAssetModes } from '../home/mobile/Dashboard/MobilePortfolio';
interface PortfolioHeaderProps {
  showCashModal: boolean;
  setShowCashModal: (bol: boolean) => void;
  assetMode: TAssetModes;
  goToNextAssetMode: () => void;
  assetData: any;
  desktop?: boolean;
  selectedNetwork: {
    name: string;
    value: string;
    logo: string;
  };
  setNetworksModalData: (_: any[] | null) => void;
}
export const PortfolioHeader = ({
  showCashModal,
  setShowCashModal,
  assetMode,
  goToNextAssetMode,
  assetData,
  desktop,
  selectedNetwork,
  setNetworksModalData
}: PortfolioHeaderProps) => {
  const networks = [{
    networkName: 'All Networks',
    totalUsdValue: assetData?.totalUsdValue,
    totalUsdRate: 100,
    chainId: 'all-networks',
    networkLogo: '/static/genius.png'
  }, ...(assetData?.balancesByChain || []).map(chain => ({
    networkName: chain.networkName || 'Unknown Network',
    totalUsdValue: chain?.totalUsdValue,
    totalUsdRate: chain.totalUsdRate,
    chainId: chain.chainId,
    networkLogo: NETWORK_LOGOS[chain.chainId]
  }))].filter(x => ACTIVE_NETWORKS?.includes(x.chainId) || x.chainId === 'all-networks');
  const chainOrder = Object.values(ChainId);
  const getChainOrder = (chainId: any) => {
    const index = chainOrder.indexOf(chainId);
    return index !== -1 ? index : chainOrder.length;
  };
  const sortedNetworks = networks.sort((a, b) => {
    if (a.chainId === 'all-networks') return -1;
    if (b.chainId === 'all-networks') return 1;
    return getChainOrder(a.chainId) - getChainOrder(b.chainId);
  });
  const selectedNetworkName = selectedNetwork?.name;
  const selectedNetworkWithData = networks.find(network => network.networkName === selectedNetworkName);
  const totalCash = () => {
    let totalUsd = 0;
    if (assetData && assetData?.balances.length) {
      assetData.balances.map(token => {
        if (token.contract_ticker_symbol === 'USDC' || token.contract_ticker_symbol === 'USDT') {
          totalUsd += token.usd_value;
        }
      });
    }
    return totalUsd.toLocaleString(undefined, {
      maximumFractionDigits: 2
    });
  };
  return <>
      <div className='w-full text-genius-cream  flex items-center py-2 justify-start border-genius-blue border-y-[1px]'>
        <div onClick={() => setShowCashModal(false)} className={`flex items-center justify-between ${showCashModal ? 'text-genius-cream/50' : 'text-genius-cream'}  text-[20px] p-2 pl-4 cursor-pointer`}>
          <p>Crypto</p>
        </div>
        <div onClick={() => setShowCashModal(true)} className={`flex items-center justify-between text-genius-cream ${showCashModal ? 'text-genius-cream' : 'text-genius-cream/50'} text-[20px] p-2 cursor-pointer`}>
          <p>Cash</p>
        </div>
      </div>
      <div className='w-full bg-genius-blue text-genius-cream'>
        <div className={`py-3 px-4 w-full flex bg-genius-indigo`}>
          <div onClick={() => setNetworksModalData(sortedNetworks)} className={classNames('font-light w-2/4 cursor-pointer flex items-center', desktop && 'w-3/12')}>
            {selectedNetwork.logo && <ImageWithFallback src={selectedNetwork.logo} alt={`${selectedNetwork.name} logo`} width={20} height={20} className='mr-4' />}
            {getNetworkName(selectedNetwork.name)}
            <IoIosArrowDown className='h-4 w-4 ml-2' data-sentry-element="IoIosArrowDown" data-sentry-source-file="PortfolioHeader.tsx" />
          </div>

          <div className={classNames('flex flex-col items-end w-2/4', desktop && 'w-5/12')}>
            <p className='flex items-center font-light'>
              {selectedNetworkWithData?.totalUsdValue ? showCashModal ? `$${totalCash()}` : `$${toSpecialFixed(selectedNetworkWithData?.totalUsdValue).value}` : ''}
            </p>
          </div>
        </div>

        <div className='py-2 px-4 w-full flex'>
          <div className={classNames('w-5/12', desktop && 'w-3/12')}>
            <p>Asset</p>
          </div>
          {desktop && <div className='w-2/12'>
              <p>Price</p>
            </div>}
          <div onClick={goToNextAssetMode} className={classNames('flex flex-col items-end w-full cursor-pointer pr-4')}>
            <p className='flex items-center justify-end'>
              {assetMode}
              <IoIosArrowDown className='h-4 w-4 ml-2' data-sentry-element="IoIosArrowDown" data-sentry-source-file="PortfolioHeader.tsx" />
            </p>
          </div>
        </div>
      </div>
    </>;
};